import './product-list.scss';

import { components } from 'gridstrap/lib/gs-components';
import { GSProductList } from './product-list';
import { GSProductListItems } from './product-list-items';
import { GSProductListFilters } from './product-list-filters';

components.register({
	selector: '.gs-ProductList',
	controller: GSProductList
});

components.register({
	selector: '.gs-ProductList-items',
	controller: GSProductListItems
});

components.register({
	selector: '.gs-ProductList-sidebar',
	controller: GSProductListFilters
});
